// import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';

//
//
export default function O() {
    const { useLang } = useGlobal();
    const { t } = useLang('RV');
    const bgImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1744364085239/o_pc.png',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1744364085101/o_h5.png',
    };

    {
        t.rich('L_text', {
            s: (text: string) => <span className="strong">{text}</span>,
            a: (text: string) => (
                <a className="link" href={`mailto:${text}`}>
                    {text}
                </a>
            ),
        });
    }
    return (
        <div id="RV-D" className={`RV-O RV-box  ${css['RV-O']}`}>
            <div className="banner-img">
                <EFPicture src={bgImg.pc} srcPad={bgImg.h5} srcMobile={bgImg.h5} />
            </div>
            <div className="text-container">
                <h3>{t('O_title')}</h3>
                <h4> {t('O_part1_title')}</h4>
                <p> {t('O_part1_desc')}</p>
                <h4> {t('O_part2_title')}</h4>
                <p className="nb">{t('O_part2_desc')}</p>
                <p className="line" />
                <h4>{t('O_part3_title')}</h4>
                <p>{t('O_part3_desc')}</p>
            </div>
        </div>
    );
}
